import { render, staticRenderFns } from "./ImportMainUpload.vue?vue&type=template&id=96e7d230&scoped=true"
import script from "./ImportMainUpload.vue?vue&type=script&lang=js"
export * from "./ImportMainUpload.vue?vue&type=script&lang=js"
import style0 from "./ImportMainUpload.vue?vue&type=style&index=0&id=96e7d230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7d230",
  null
  
)

export default component.exports